import { buildUrl, usKidsGolfService } from '@/libs/api/instances/us-kids-golf-instance';

import type { CoachNotificationsResponse } from '../notifications/types';

const notificationsUrl = buildUrl('/coaches/me/notifications');

export type CoachNotificationsParams = {
  limit: number;
  cursor?: string;
  paginate: true;
};

export async function fetchCoachNotifications(
  params: CoachNotificationsParams,
): Promise<CoachNotificationsResponse> {
  return await usKidsGolfService.get<CoachNotificationsResponse>(notificationsUrl, params);
}

export async function markCoachNotificationRead(id: string): Promise<void> {
  await usKidsGolfService.patch<void>(`${notificationsUrl}/${id}/read`);
}

export async function markAllCoachNotificationsRead(): Promise<void> {
  await usKidsGolfService.patch<void>(`${notificationsUrl}/read-all`);
}

export async function deleteCoachNotification(id: string): Promise<void> {
  await usKidsGolfService.delete<void>(`${notificationsUrl}/${id}`);
}
